import { SfCheckMarkCircleIcon } from 'fitify-ui/src/Icon/fill/SfCheckMarkCircleIcon'
import { SfChevronForwardCircleIcon } from 'fitify-ui/src/Icon/fill/SfChevronForwardCircleIcon'
import { SfChevronForwardIcon } from 'fitify-ui/src/Icon/outline/SfChevronForwardIcon'
import { SfCircleIcon } from 'fitify-ui/src/Icon/outline/SfCircleIcon'
import { useMemo } from 'react'

import { StyledRadio } from './Radio.Styled'
import type { RadioProps } from './Radio.Types'

export const Radio = ({
  colorVariant = 'default',
  isDisabled = false,
  isSelected = false,
  unselectedVariant,
}: RadioProps) => {
  const unselectedIcon = useMemo(() => {
    switch (unselectedVariant) {
      case 'circle':
        return <SfCircleIcon />
      case 'chevron-forward':
        return <SfChevronForwardIcon />
      case 'chevron-forward-circle':
        return <SfChevronForwardCircleIcon />
      case 'none':
      default:
        return null
    }
  }, [unselectedVariant])

  return (
    <StyledRadio
      $colorVariant={colorVariant}
      $isDisabled={isDisabled}
      $isSelected={isSelected}
      $unselectedVariant={unselectedVariant}
    >
      {isSelected ? <SfCheckMarkCircleIcon /> : unselectedIcon}
    </StyledRadio>
  )
}
